// File upload view

export const FILE_UPLOADING_PROGRESS = {
  STARTED: 1,
  RETRIEVING_TMP_LINK: 4,
  SENDING_TO_S3: 45,
  VERIFYING: 24,
  CREATING_EDITION_STARTED: 2,
  CREATING_EDITION_FINISHED: 24,
  VERIFYING_INCREMENT_COEFF: 0.4,
}

export const FILE_UPLOAD_TIMEOUT = 30000
export const POLLING_TIMEOUT = 60000
export const POLLING_INTERVAL = 1000

// Paste Image

export const DEFAULT_PASTED_IMAGE_NAME = 'image.png'
export const PASTED_IMAGE_REPLACEMENT_NAME = 'Pasted image'
export const PASTED_IMAGE_REPLACEMENT_EXT = 'png'

// Miscellaneous

export const ALLOWED_ARCHIVE_EXTENSION = 'zip'
